import { withMsal } from '@azure/msal-react';
import { clearSession } from '../../../store/utility';
import { Button, IconButton } from '@upmc/ims.component-library';
import Login from '@mui/icons-material/Login';
import Logout from '@mui/icons-material/Logout';
import { Tooltip } from '../../UI/MDC/Tooltip/Tooltip';
import { CONTENT_ALIGNMENT } from '../../UI/MDC/Tooltip/_types';

const LoginButton = ({ align = CONTENT_ALIGNMENT.BOTTOM, ...props }) => {
	const isAuthenticated = props.msalContext.accounts.length > 0;
	const msalInstance = props.msalContext.instance;
	const textAction = isAuthenticated ? 'Logout' : 'Login';
	const elIcon = isAuthenticated ? <Logout /> : <Login />;

	const onClickHandler = () => {
		if (isAuthenticated) {
			clearSession();
			msalInstance.logoutRedirect();
		} else {
			msalInstance.loginRedirect();
		}
	};

	return props.isIcon ? (
		<Tooltip align={align} content={textAction}>
			<IconButton onClick={onClickHandler} size='large'>
				{elIcon}
			</IconButton>
		</Tooltip>
	) : (
		<Button variant="text" startIcon={elIcon} onClick={onClickHandler} sx={{ m: '10px' }}>
			{textAction}
		</Button>
	);
};

export default withMsal(LoginButton);
